// eslint-disable-next-line import/prefer-default-export
export const interestRate =  [
    {
        "value": "2.00",
        "label": "2.00%"
    },
    {
        "value": "2.25",
        "label": "2.25%"
    },
    {
        "value": "2.50",
        "label": "2.50%"
    },
    {
        "value": "2.75",
        "label": "2.75%"
    },
    {
        "value": "3.00",
        "label": "3.00%"
    },
    {
        "value": "3.25",
        "label": "3.25%"
    },
    {
        "value": "3.50",
        "label": "3.50%"
    },
    {
        "value": "3.75",
        "label": "3.75%"
    },
    {
        "value": "4.00",
        "label": "4.00%"
    },
    {
        "value": "4.25",
        "label": "4.25%"
    },
    {
        "value": "4.50",
        "label": "4.50%"
    },
    {
        "value": "4.75",
        "label": "4.75%"
    },
    {
        "value": "5.00",
        "label": "5.00%"
    },
    {
        "value": "5.25",
        "label": "5.25%"
    },
    {
        "value": "5.50",
        "label": "5.50%"
    },
    {
        "value": "5.75",
        "label": "5.75%"
    },
    {
        "value": "6.00",
        "label": "6.00%"
    },
    {
        "value": "6.25",
        "label": "6.25%"
    },
    {
        "value": "6.50",
        "label": "6.50%"
    },
    {
        "value": "6.75",
        "label": "6.75%"
    },
    {
        "value": "7.00",
        "label": "7.00%"
    },
    {
        "value": "7.25",
        "label": "7.25%"
    },
    {
        "value": "7.50",
        "label": "7.50%"
    },
    {
        "value": "7.75",
        "label": "7.75%"
    },
    {
        "value": "8.00",
        "label": "8.00%"
    },
    {
        "value": "8.25",
        "label": "8.25%"
    },
    {
        "value": "8.50",
        "label": "8.50%"
    },
    {
        "value": "8.75",
        "label": "8.75%"
    },
    {
        "value": "9.00",
        "label": "9.00%"
    },
    {
        "value": "9.25",
        "label": "9.25%"
    },
    {
        "value": "9.50",
        "label": "9.50%"
    },
    {
        "value": "9.75",
        "label": "9.75%"
    },
    {
        "value": "10.00",
        "label": "10.00%"
    },
    {
        "value": "10.25",
        "label": "10.25%"
    },
    {
        "value": "10.50",
        "label": "10.50%"
    },
    {
        "value": "10.75",
        "label": "10.75%"
    },
    {
        "value": "11.00",
        "label": "11%+"
    }
]